export default __webpack_public_path__ + "static/media/cabello-mujer-castano.b1d4f7bf.png";